import { ChangeDetectorRef, Component, ComponentFactoryResolver, inject, OnInit } from '@angular/core';
import {
  CheckoutWrapperComponent,
  OrderSubmitService,
  CheckoutConfigService,
  CartService,
  GungModalService,
  CartKeyService,
  CartListCheckoutConfigService
} from 'gung-standard';
import { CultUnifaunReturnsService, ShipmentPrints } from '../../../services/cult-unifaun-returns.service';

@Component({
  selector: 'cult-cult-checkout-wrapper',
  templateUrl: './cult-checkout-wrapper.component.html',
  styleUrls: ['./cult-checkout-wrapper.component.scss'],
  standalone: false
})
export class CultCheckoutWrapperComponent extends CheckoutWrapperComponent {
  protected cultUnifaunReturnsService = inject(CultUnifaunReturnsService);

  openShipmentPdfNewWindow(shipmentPrint: ShipmentPrints) {
    this.cultUnifaunReturnsService.openShipmentPdfNewWindow(shipmentPrint);
  }
}
